import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/inherits.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import parse from 'html-react-parser';
export var DisclosureWithSymbol = /*#__PURE__*/function (_React$Component) {
  function DisclosureWithSymbol() {
    _classCallCheck(this, DisclosureWithSymbol);
    return _callSuper(this, DisclosureWithSymbol, arguments);
  }
  _inherits(DisclosureWithSymbol, _React$Component);
  return _createClass(DisclosureWithSymbol, [{
    key: "render",
    value: function render() {
      var _ref;
      var _this$props = this.props,
        className = _this$props.className,
        symbol = _this$props.symbol,
        disclosure = _this$props.disclosure,
        toSuperscriptSymbol = _this$props.toSuperscriptSymbol,
        id = _this$props.id;
      var cl = className ? "".concat(className, " ") : '';
      var actualSymbol = (_ref = symbol !== null && symbol !== void 0 ? symbol : disclosure.symbol) !== null && _ref !== void 0 ? _ref : '';
      var returnSymbol = function returnSymbol(s) {
        if (!s) return '';
        var shouldSuperscript = toSuperscriptSymbol === true ? true : toSuperscriptSymbol === false ? false : s !== '*'; // default: do not superscript * only
        return shouldSuperscript ? "<sup>".concat(s, "</sup>") : s;
      };
      return React.createElement("p", _objectSpread({
        id: id || disclosure.id
      }, cl ? {
        className: cl.trim()
      } : {}), parse("".concat(returnSymbol(actualSymbol))), typeof disclosure.copy === 'string' ? parse(disclosure.copy) : disclosure.copy);
    }
  }]);
}(React.Component);
export var DisclosureSymbolLink = /*#__PURE__*/function (_React$Component2) {
  function DisclosureSymbolLink() {
    _classCallCheck(this, DisclosureSymbolLink);
    return _callSuper(this, DisclosureSymbolLink, arguments);
  }
  _inherits(DisclosureSymbolLink, _React$Component2);
  return _createClass(DisclosureSymbolLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        className = _this$props2.className,
        symbol = _this$props2.symbol,
        disclosure = _this$props2.disclosure,
        toSuperscriptSymbol = _this$props2.toSuperscriptSymbol,
        smallSymbol = _this$props2.smallSymbol,
        id = _this$props2.id,
        disclosureLink = _this$props2.disclosureLink;
      var cl = className ? "".concat(className, " ") : '';
      var returnSymbol = function returnSymbol(s) {
        var shouldSuperscript = toSuperscriptSymbol === true ? true : toSuperscriptSymbol === false ? false : s !== '*'; // default: do not superscript *
        return shouldSuperscript ? React.createElement("sup", _objectSpread({}, smallSymbol ? {
          className: 'small'
        } : {}), s) : s;
      };
      var ariaProps = id !== '' ? {
        'aria-describedby': id || disclosure.id
      } : {};
      return React.createElement("a", _objectSpread(_objectSpread({
        className: "disclosure-symbol ".concat(cl).trim(),
        href: disclosureLink || "#".concat(id || disclosure.id)
      }, ariaProps), {}, {
        "aria-label": "See disclosure details."
      }), returnSymbol(symbol || disclosure.symbol || ''));
    }
  }]);
}(React.Component);
export var DisclosureSymbol = /*#__PURE__*/function (_React$Component3) {
  function DisclosureSymbol() {
    _classCallCheck(this, DisclosureSymbol);
    return _callSuper(this, DisclosureSymbol, arguments);
  }
  _inherits(DisclosureSymbol, _React$Component3);
  return _createClass(DisclosureSymbol, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        className = _this$props3.className,
        symbol = _this$props3.symbol,
        disclosure = _this$props3.disclosure,
        smallSymbol = _this$props3.smallSymbol,
        id = _this$props3.id;
      var cl = "".concat(className || '').concat(smallSymbol ? ' small' : '');
      // Only add aria-describedby if `id` is not explicitly an empty string
      var ariaProps = id !== '' ? {
        'aria-describedby': id || disclosure.id
      } : {};
      return React.createElement("sup", _objectSpread(_objectSpread({}, cl ? {
        className: cl.trim()
      } : {}), ariaProps), symbol || disclosure.symbol || '');
    }
  }]);
}(React.Component);
export var DisclosuresWrapper = /*#__PURE__*/function (_React$Component4) {
  function DisclosuresWrapper() {
    _classCallCheck(this, DisclosuresWrapper);
    return _callSuper(this, DisclosuresWrapper, arguments);
  }
  _inherits(DisclosuresWrapper, _React$Component4);
  return _createClass(DisclosuresWrapper, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        _this$props4$classNam = _this$props4.className,
        className = _this$props4$classNam === void 0 ? '' : _this$props4$classNam,
        children = _this$props4.children,
        id = _this$props4.id;
      var props = _objectSpread({
        role: 'note',
        className: "disclosures ".concat(className).trim()
      }, id ? {
        id: id
      } : {});
      return React.createElement("aside", _objectSpread({}, props), children);
    }
  }]);
}(React.Component);